<template>
  <font-awesome-icon
    class="text-palette2 animate-spin mx-auto"
    icon="spinner"
    size="lg"
  />
</template>